import { createSlice } from '@reduxjs/toolkit';

const audioSlice = createSlice({
  name: 'audio',
  initialState: {
    audios: [],
    currentAudio: null,
    currentPage: 1,
    totalPages: 1,
    totalAudios: 0,
    // The query behind `audios`, so a write can refetch what the user is looking at now.
    query: null,
    loading: false,
    detailLoading: false,
    saving: false,
    bulkSaving: false,
    bulkCompletedAt: 0,
    error: null,
    success: false,
  },
  reducers: {
    getAudiosAction: (state, action) => {
      state.query = action.payload;
      state.loading = true;
      state.error = null;
    },
    getAudiosSuccess: (state, action) => {
      // Handle response structure: { success: true, data: [...] }
      const responseData = action.payload?.data || action.payload?.results || [];
      state.audios = Array.isArray(responseData) ? responseData : [];
      state.currentPage = action.payload?.page || 1;
      state.totalPages = action.payload?.total_pages || 1;
      state.totalAudios = action.payload?.count || action.payload?.total || state.audios.length;
      state.loading = false;
      state.error = null;
    },
    getAudiosFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createAudioAction: (state) => {
      state.saving = true;
      state.error = null;
      state.success = false;
    },
    createAudioSuccess: (state) => {
      state.saving = false;
      state.error = null;
      state.success = true;
    },
    createAudioFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },
    updateAudioAction: (state) => {
      state.saving = true;
      state.error = null;
      state.success = false;
    },
    updateAudioSuccess: (state) => {
      state.saving = false;
      state.error = null;
      state.success = true;
    },
    updateAudioFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },
    deleteAudioAction: (state) => {
      state.saving = true;
      state.error = null;
    },
    deleteAudioSuccess: (state) => {
      state.saving = false;
      state.error = null;
    },
    deleteAudioFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },
    bulkUpdateAudioAttributesAction: (state) => {
      state.bulkSaving = true;
      state.error = null;
    },
    bulkUpdateAudioAttributesSuccess: (state) => {
      state.bulkSaving = false;
      state.bulkCompletedAt += 1;
    },
    bulkUpdateAudioAttributesFailure: (state, action) => {
      state.bulkSaving = false;
      state.error = action.payload;
    },
    bulkDeleteAudiosAction: (state) => {
      state.bulkSaving = true;
      state.error = null;
    },
    bulkDeleteAudiosSuccess: (state) => {
      state.bulkSaving = false;
      state.bulkCompletedAt += 1;
    },
    bulkDeleteAudiosFailure: (state, action) => {
      state.bulkSaving = false;
      state.error = action.payload;
    },
    getAudioByIdAction: (state) => {
      state.detailLoading = true;
      state.error = null;
    },
    getAudioByIdSuccess: (state, action) => {
      state.currentAudio = action.payload?.data || action.payload;
      state.detailLoading = false;
      state.error = null;
    },
    getAudioByIdFailure: (state, action) => {
      state.detailLoading = false;
      state.error = action.payload;
      state.currentAudio = null;
    },
    clearCurrentAudio: (state) => {
      state.currentAudio = null;
    },
    resetAudioStatus: (state) => {
      state.success = false;
      state.error = null;
    },
  },
});

export const {
  getAudiosAction,
  getAudiosSuccess,
  getAudiosFailure,
  createAudioAction,
  createAudioSuccess,
  createAudioFailure,
  updateAudioAction,
  updateAudioSuccess,
  updateAudioFailure,
  deleteAudioAction,
  deleteAudioSuccess,
  deleteAudioFailure,
  bulkUpdateAudioAttributesAction,
  bulkUpdateAudioAttributesSuccess,
  bulkUpdateAudioAttributesFailure,
  bulkDeleteAudiosAction,
  bulkDeleteAudiosSuccess,
  bulkDeleteAudiosFailure,
  getAudioByIdAction,
  getAudioByIdSuccess,
  getAudioByIdFailure,
  clearCurrentAudio,
  resetAudioStatus,
} = audioSlice.actions;

export { audioSlice };
